export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M11.562 3c1.66 0 3 1.34 3 3v4.927L8.707 5.073A2.996 2.996 0 0111.562 3zm5.832 9c.61 0 1.1.54 1 1.14a6.928 6.928 0 01-.34 1.287l-1.63-1.63a.996.996 0 01.97-.797zm-5.832 3c-1.66 0-3-1.34-3-3v-.43l3.403 3.403a3.05 3.05 0 01-.403.027zm-4.93-2.15c.41 2.35 2.46 4.15 4.93 4.15.711 0 1.388-.15 2-.418l1.485 1.484a6.97 6.97 0 01-2.486.854V21c0 .55-.45 1-1 1s-1-.45-1-1v-2.08a6.993 6.993 0 01-5.91-5.78c-.09-.6.39-1.14 1-1.14.49 0 .9.36.98.85z\" clip-rule=\"evenodd\"/><path fill=\"#EA3917\" fill-rule=\"evenodd\" d=\"M4.247 3.93a.842.842 0 011.19 0l14.316 14.317a.842.842 0 11-1.19 1.19L4.246 5.123a.842.842 0 010-1.191z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};